<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 tag">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header border-bottom">
            <div class="tag d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Kapcsolat Lista</h5>
              </div>
              <div class="col-6 text-end">
                <material-button
                    class="float-right btn btm-sm"
                    @click="this.$router.push({ name: 'Add Contact' })"
                >
                  <i class="fas fa-tag me-2"></i>
                  Kapcsolat Hozzáadása
                </material-button>
              </div>
            </div>
          </div>

          <!-- Card body -->
          <div class="px-0 pb-0 card-body">

            <div class="table-responsive p-4">
              <!-- Table -->
              <DataTable id="dataTable" :data="data" :columns="columns" :options="dataTableOptions" ref="table"
                         class="table table-flush dataTable-table" width="100%">
                <template #action="props">
                  <td
                      class="dt-control"
                      :text="`Col 1: ${props.cellData}`"
                      @click="rowClick"
                  ></td>
                </template>
              </DataTable>
            </div>

          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue';
import $ from "jquery";
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import eventTable from "@/mixins/eventTable.js";
import store from "@/store";
import _ from "lodash";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import BasePagination from "@/components/BasePagination.vue";
import {emptyTableContent, pagination} from "../../../consts";

DataTable.use(DataTablesCore);

var sortDirection = "created_at";

const getContactsList = _.debounce(async function (params) {
  await store.dispatch("contacts/getContacts");
}, 300);

export default {
  name: "ContactsList",
  components: {
    MaterialButton,
    MaterialInput,
    BasePagination,
    DataTable
  },
  mixins: [eventTable],
  setup() {
    const data = ref([]);
    const table = ref();
    const columns = [
      {title: 'Név'},
      {title: 'Besorolás'},
      {title: 'Kapcsolattartó'},
      {title: 'Telefonszám'},
      {title: 'E-Mail cím'},
      {title: 'Státusz'},
      {title: 'Műveletek', class: 'operations-column'},
    ];

    const dataTableOptions = ref(pagination);

    return {
      columns,
      dataTableOptions,
      data,
      table,
    }
  },
  data() {
    return {
      search: "",
      dataContacts: [],
      pagination: {},
      dataTable: null,
      keys: null,
    };
  },
  computed: {
    contactsList() {
      return this.$store.getters["contacts/getContactsData"];
    },
    contactsStatus() {
      return this.$store.getters["contacts/getStatusData"];
    },
    getContactTypes() {
      return this.$store.getters["contacttypes/getContactTypesData"];
    },
    metaPage() {
      return this.$store.getters["contacts/getContactsMeta"];
    },
  },
  watch: {
    contactsList: {
      handler: "reactiveTable",
      immediate: false,
      deep: true,
    },
  },
  async mounted() {
    try {
      await Promise.all([
        store.dispatch("contacttypes/getContactTypes"),
        store.dispatch("contacts/getStatus"),
        getContactsList({
          sort: sortDirection,
          query: "",
          //nr: getCurrentPage,
          //perpage: this.dataTable.options.perPage,
        }),
      ]);

      $('#dataTable .dt-empty').html(emptyTableContent);
    } catch (error) {
      console.error("Hiba az adatok betöltése közben:", error);
    }
  },
  beforeUnmount() {
    sortDirection = "created_at";
  },
  methods: {
    async getDataFromPage(page) {
      await getcontactsList({
        sort: sortDirection,
        query: this.search,
        nr: page,
        perpage: this.dataTable.options.perPage,
      });
    },
    getContactTypeName(typeId) {
      if (!this.getContactTypes || !this.getContactTypes.length) return '-';
      
      const contactType = this.getContactTypes?.find(item => String(item.id) === String(typeId));
      
      if (contactType) {
        return contactType.name;
      } else {
        return '-';
      }
    },
    getStatus(contactId) {
      if (!this.contactsStatus || !this.contactsStatus.length) return '';
      
      const statusObj = this.contactsStatus?.find(item => item.id === contactId);
      
      if (!statusObj) return '';
      
      return statusObj.status === 1 ? 'Aktív' : '';
    },
    async reactiveTable() {
      this.dataContacts = [];
      if (this.contactsList.length > 0) {
        this.contactsList.forEach((contact) => {
          this.dataContacts.push([
            contact.name,
            this.getContactTypeName(contact.contact_types_id),
            contact.contact,
            contact.phone_number,
            contact.email,
            this.getStatus(contact.contact_types_id),
            `${
                this.actionEditButton(contact.id, "Kontakt módosítása") +
                this.actionDeleteButton(contact.id, "Kontakt törlése")
            }`,
          ]);
        });

        this.data = this.dataContacts;
        this.removeEvent();
        await this.$nextTick();
        this.eventToCall({
          table: this.dataTable,
          myUserId: null,
          redirectPath: "Edit Contact",
          deletePath: "contacts/deleteContact",
          getPath: "contacts/getContacts",
          textDelete: "Kontakt sikeresen törölve!",
          textDefaultData: "contacts",
        });
      }
    },
  },
};
</script>